import { Locale, LOCALES } from "@snubes/snubes-types";

export const I18N_SETTINGS = {
  fallbackLng: "en" satisfies Locale,
  languages: LOCALES,
  defaultNS: "common",
  cookieName: "i18next_locale",
} as const;
